<template>
  <div>
    <el-tabs class="integral-tab" @tab-click="onClickTab" v-model="search.type">
      <el-tab-pane label="好课推荐" name="1"></el-tab-pane>
      <el-tab-pane
        label="热门实物商品"
        name="2"
        v-if="$store.state.commonSetting.switch_goods_module == 1"
      ></el-tab-pane>
    </el-tabs>
    <List ref="list" class="list" url="/api/integral/shop/index" :search="search">
      <template v-slot="{ list }">
        <IntegralGoodsList :type="search.type" :list="list"></IntegralGoodsList>
      </template>
    </List>
  </div>
</template>
<script>
import List from '@/components/List';
import IntegralGoodsList from '../../../components/Integral/IntegralGoodsList';
export default {
  name: 'MemberIntegralStore',
  components: {
    List,
    IntegralGoodsList,
  },
  props: {
    type: {
      type: String,
      default: 'good',
    },
  },
  data() {
    return {
      search: {
        type: '1',
        limit: 9,
      },
      pageSize: 3,
      current: '1',
    };
  },
  watch: {
    type: {
      immediate: true,
      deep: true,
      handler(value) {
        this.search.type = value == 'good' ? '1' : '2';
      },
    },
  },
  methods: {
    onClickTab(tab) {
      if (tab.name == 1) {
        this.search.limit = 9;
      } else {
        this.search.limit = 8;
      }
      this.$refs.list.searchRefresh();
    },
  },
};
</script>
<style lang="scss" scoped>
.tab-2 {
  padding-left: 25px;
}

.integral-tab {
  padding-left: 25px;

  ::v-deep {
    .el-tabs__header {
      margin-bottom: 20px;
    }

    .el-tabs__nav-wrap {
      padding-left: 0 !important;

      &::after {
        display: none;
      }
    }
  }
}

.list {
  overflow: hidden;

  ::v-deep {
    .pager {
      margin: 5px 0 25px 0;
    }
  }
}
</style>
